



































import { Component, Vue } from "vue-property-decorator";
import {
  TitleTemplatePublic,
  RedCapital,
  SelectedCountry,
  RedCapitalConfig
} from "@/configuration";

@Component({
  metaInfo: {
    title: "404",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry
    };
  }
})
export default class NotFound extends Vue {}
